import { render } from "./ShoppingGuide.vue?vue&type=template&id=e7302b34&scoped=true"
import script from "./ShoppingGuide.vue?vue&type=script&lang=js"
export * from "./ShoppingGuide.vue?vue&type=script&lang=js"

import "./ShoppingGuide.vue?vue&type=style&index=0&id=e7302b34&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-e7302b34"

export default script